import { appId } from '../constants';

export function getLocalStorage(key: string) {
    return localStorage.getItem(`${appId}-${key}`);
}

export function setLocalStorage(key: string, value: string) {
    localStorage.setItem(`${appId}-${key}`, value);
}
